import React from 'react'
import { LoadingIcon } from '../../icons'
import './style.less'

export type LoadingIndicatorProps = {
  loading?: boolean
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = (props) => {
  return (
    <div className={`loading-wrapper${props.loading ? ' active' : ''}`}>
      <div className="loading">
        <LoadingIcon />
      </div>
    </div>
  )
}
